export const PRINT_HEADER_TITLE = "منصة طرح لمنافسات القطاع الخاص";

export const withTemporaryDocumentTitle = (title, fn) => {
  if (typeof document === "undefined") return fn?.();
  const previous = document.title;
  document.title = title || previous;

  try {
    return fn?.();
  } finally {
    // Some browsers read the title synchronously when print starts, so restore later too.
    window.setTimeout(() => {
      try {
        document.title = previous;
      } catch {
        // ignore
      }
    }, 500);
  }
};

export const printCurrentPageWithTitle = (
  title = PRINT_HEADER_TITLE,
  { delayMs = 0 } = {}
) => {
  if (typeof window === "undefined") return;

  const doPrint = () => window.print();

  if (typeof document === "undefined") {
    window.setTimeout(doPrint, delayMs);
    return;
  }

  const previous = document.title;
  document.title = title || previous;

  let restored = false;
  const restore = () => {
    if (restored) return;
    restored = true;
    try {
      document.title = previous;
    } catch {
      // ignore
    }
  };

  // Restore after printing, and also with a fallback timer.
  const onAfterPrint = () => restore();
  window.addEventListener("afterprint", onAfterPrint, { once: true });
  window.setTimeout(restore, Math.max(8000, delayMs + 2000));

  window.setTimeout(doPrint, delayMs);
};

